var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container"},[_c('radar-spinner',{attrs:{"animation-duration":1000,"size":120,"color":'#4E5BF2'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }